import { atom, type WritableAtom } from 'jotai';

export type EntityVerificationDrawerOpenAtom = WritableAtom<boolean, [boolean], void>;

export interface EntityVerificationAtomsPort {
  /** The app panel atom; opening it closes the sibling right-side panels. */
  drawerOpenAtom: EntityVerificationDrawerOpenAtom;
}

const localDrawerOpenAtom = atom(false);
let port: EntityVerificationAtomsPort | null = null;

export function configureEntityVerificationAtoms(
  next: EntityVerificationAtomsPort
): void {
  port = next;
}

// Read on every get/set, never at module evaluation, so configuring late is safe.
const drawerTarget = (): EntityVerificationDrawerOpenAtom =>
  port?.drawerOpenAtom ?? localDrawerOpenAtom;

export const entityVerificationDrawerOpenAtom = atom(
  (get) => get(drawerTarget()),
  (_get, set, next: boolean) => {
    set(drawerTarget(), next);
  }
);
